import { maintenanceWindows } from './maintenanceWindows';

/**
 * Returns true when the current timestamp is within any configured maintenance window.
 * @param maintenanceWindows - An array of maintenance windows, each defined by a start and end time in UTC milliseconds.
 * @returns A boolean indicating whether the current time is within a maintenance window.
 */

export type MaintenanceWindow = {
  start: number;
  end: number;
};
export const maintenanceWindowActive = (mw: MaintenanceWindow[] = maintenanceWindows): boolean => {
  if (!mw.length) {
    return false;
  }
  const now = Date.now();

  return mw.some(({ start, end }) => {
    return now >= start && now <= end;
  });
};
